import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stencil",
  "use": "icon-stencil-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-stencil\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M5.78,8.44H18.22V5.78H5.78Zm8,9.78v-8h-8v8Zm1.78,0h2.66v-8H15.56ZM4.89,4H19.11a.89.89,0,0,1,.89.89V19.11a.89.89,0,0,1-.89.89H4.89A.89.89,0,0,1,4,19.11V4.89A.89.89,0,0,1,4.89,4Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol